import { useEffect, useState } from 'react'
import { RoomEvent } from 'livekit-client'
import { Participant } from 'livekit-client'
import { useRoomContext } from '@/RoomContext'
import { motion } from 'framer-motion'
import { cn } from '@/utlis/cn'
import useRoomActions from '@/services/useRoomActions'

type ActiveSpeakerIndicatorProps = {
    participantSessionId: string
    className?: string
}
function ActiveSpeakerIndicator({ participantSessionId, className }: ActiveSpeakerIndicatorProps) {
    const [roomState] = useRoomContext()
    const sfuRoom = roomState.sfuRoom

    const { calcIsRemoteAudioDeviceAllMuted } = useRoomActions()

    const muted = calcIsRemoteAudioDeviceAllMuted(roomState.peers[participantSessionId])

    const [activeSpeakers, setActiveSpeakers] = useState<string[]>([])

    useEffect(() => {
        if (sfuRoom) {
            function handleActiveSpeakersChanged(speakers: Participant[]) {
                setActiveSpeakers(speakers.map((speaker) => speaker.identity))
            }

            sfuRoom.on(RoomEvent.ActiveSpeakersChanged, handleActiveSpeakersChanged)

            return () => {
                sfuRoom.off(RoomEvent.ActiveSpeakersChanged, handleActiveSpeakersChanged)
            }
        }
    }, [sfuRoom])

    const isActive = activeSpeakers.includes(participantSessionId) && !muted

    return (
        <motion.div
            className={cn(
                `
                absolute
                border-[2px]
                border-yellow-500
                opacity-0
                inset-0
                z-11
                pointer-events-none
                transform-200
            `,
                className
            )}
            animate={{
                opacity: isActive ? 100 : 0,
            }}
        />
    )
}

export default ActiveSpeakerIndicator
